import {Button, Card, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {ScheduledComp} from '../types';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {Calender} from '@jobseeker/lotus/assets/icons';
import {Tooltip} from '@jobseeker/lotus/elements';

function ScheduledInterview(props: ScheduledComp) {
  return (
    <>
      {props.date && props.date.length > 0 ? (
        <Card
          sx={{
            mb: {xxs: 0.5, md: 0},
            mt: {xxs: 2, md: 0},
            width: {lg: 142, md: 125, xxs: 328},
            borderColor: '#49966E',
            borderWidth: '1.2px',
            borderStyle: 'solid',
            borderRadius: '6px',
            backgroundColor: 'var(--Lighter-Green, rgba(145, 184, 121, 0.16))',
            padding: '4px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 0.25,
            }}
          >
            <Image
              src={Calender}
              height={10}
              width={10}
              alt=""
              style={{marginRight: 0.5}}
            ></Image>
            <Typography
              variant="caption"
              sx={{fontSize: 10, color: '#333', fontWeight: 600}}
            >
              &nbsp;INTERVIEW SLOT
            </Typography>
          </div>
          <Typography
            variant="caption"
            sx={{fontSize: 10, color: '#333', fontWeight: 500}}
          >
            {props.date}
          </Typography>
        </Card>
      ) : props.remSlots ? (
        <Button
          variant="contained"
          disabled={props.remSlots == 0}
          sx={{
            fontSize: 12,
            width: {xs: '100%', md: 125}, // Full width on xxs, 125px on larger screens
            ml: {xs: 1, md: 0}, // Margin left 8px on xxs, 0 on larger screens
            mr: {xs: 1, md: 0}, // Margin right 8px on xxs, 0 on larger screens
            mb: {xxs: 0.5, md: 0},
            mt: {xxs: 2, md: 0},
            height: {xxs: '32px'}, // Set a fixed height to maintain consistency
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center', // Center the text horizontally
            backgroundColor: '#333',
            color: 'white',
            borderRadius: 8,
            padding: '8px 12px',
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#444',
              boxShadow: 'none',
            },
          }}
          onClick={
            props.remSlots
              ? () => {
                  openUrl(
                    `/cal/pick-date/${props.calId}/${props.slotId}`,
                    '_blank'
                  );
                }
              : () => {}
          }
        >
          Choose Slot
        </Button>
      ) : (
        <Tooltip
          placement="bottom-end"
          arrow
          title={
            <Typography
              variant="subtitle3"
              lineHeight="16px"
              sx={{
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
              }}
            >
              All Interview Slots have been booked by other Candidates. We will
              come back to you as and when more interview slots open up.
            </Typography>
          }
        >
          <Button
            variant="contained"
            disabled={props.remSlots == 0}
            sx={{
              fontSize: 12,
              width: {xs: '100%', md: 125}, // Full width on xxs, 125px on larger screens
              ml: {xs: 1, md: 0}, // Margin left 8px on xxs, 0 on larger screens
              mr: {xs: 1, md: 0}, // Margin right 8px on xxs, 0 on larger screens
              mb: {xxs: 0.5, md: 0},
              mt: {xxs: 2, md: 0},
              height: {xxs: '32px'}, // Set a fixed height to maintain consistency
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center', // Center the text horizontally
              backgroundColor: '#333',
              color: 'white',
              borderRadius: 8,
              padding: '8px 12px',
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#444',
                boxShadow: 'none',
              },
            }}
          >
            Choose Slot
          </Button>
        </Tooltip>
      )}
    </>
  );
}

export default ScheduledInterview;
